//====================================================
//  Function: Select
//====================================================
function componentSelect() {
  if ($('.js-select').length) {
    $('.js-select')
      .select2({
        minimumResultsForSearch: Infinity,
        placeholder: function () {
          $(this).data('placeholder')
        },
      })
      .focus(function () {
        $(this).select2('open')
      })

    selectEvents($('.js-select'))
  }
}

function selectEvents(element) {
  element.on('select2:open', function (e) {
    $(this).closest('.js-placeholder-block').addClass(classIsActive)
  })

  element.on('select2:select', function (e) {
    $(this).closest('.js-placeholder-block').addClass(classIsActive)
    $(this).trigger('input')

    if (e.target.dataset.type === 'transaction-history') {
      var selectValue = e.target.value
      var firstInvest = e.target.dataset.firstinvest
      setHistoryCalendar(selectValue, firstInvest)
    }
  })

  element.on('select2:close', function (e) {
    if (!$(this).val().length) {
      $(this).closest('.js-placeholder-block').removeClass(classIsActive)
    }
  })
}

function setHistoryCalendar(value, firstInvest) {
  console.log(value)
  switch (value) {
    case 'all':
      clearCalendar()
      calendarDateFrom.clear()
      calendarDateTo.clear()
      // var today = moment().format('YYYY-MM-DD')
      // calendarDateFrom.setDate(firstInvest)
      // calendarDateTo.setDate(today)

      // calendarDateFrom.set('enable', [''])
      // calendarDateTo.set('enable', [''])
      break
    case 'today':
      var today = moment().format('YYYY-MM-DD')

      clearCalendar()
      calendarDateFrom.setDate(today)
      calendarDateTo.setDate(today)

      calendarDateFrom.set('enable', [today])
      calendarDateTo.set('enable', [today])
      break
    case 'yesterday':
      var yesterday = moment().subtract(1, 'days').format('YYYY-MM-DD')

      clearCalendar()
      calendarDateFrom.setDate(yesterday)
      calendarDateTo.setDate(yesterday)

      calendarDateFrom.set('enable', [yesterday])
      calendarDateTo.set('enable', [yesterday])
      break
    case 'this_month':
      var startOfMonth = moment().startOf('month').format('YYYY-MM-DD')
      var endOfMonth = moment().endOf('month').format('YYYY-MM-DD')
      clearCalendar()

      calendarDateFrom.setDate(startOfMonth)
      calendarDateTo.setDate(endOfMonth)

      calendarDateFrom.set('enable', [{ from: startOfMonth, to: endOfMonth }])
      calendarDateTo.set('enable', [{ from: startOfMonth, to: endOfMonth }])
      break
    case 'last_month':
      var startOfLastMonth = moment()
        .subtract(1, 'month')
        .startOf('month')
        .format('YYYY-MM-DD')
      var endOfLastMonth = moment()
        .subtract(1, 'month')
        .endOf('month')
        .format('YYYY-MM-DD')

      clearCalendar()
      calendarDateFrom.setDate(startOfLastMonth)
      calendarDateTo.setDate(endOfLastMonth)

      calendarDateFrom.set('enable', [
        { from: startOfLastMonth, to: endOfLastMonth },
      ])
      calendarDateTo.set('enable', [
        { from: startOfLastMonth, to: endOfLastMonth },
      ])
      break
    case 'this_year':
      var startOfYear = moment().startOf('year').format('YYYY-MM-DD')
      var endOfYear = moment().endOf('year').format('YYYY-MM-DD')
      clearCalendar()

      calendarDateFrom.setDate(startOfYear)
      calendarDateTo.setDate(endOfYear)

      calendarDateFrom.set('enable', [{ from: startOfYear, to: endOfYear }])
      calendarDateTo.set('enable', [{ from: startOfYear, to: endOfYear }])

      break
    case 'last_year':
      var startOfLastYear = moment()
        .subtract(1, 'year')
        .startOf('year')
        .format('YYYY-MM-DD')
      var endOfLastYear = moment()
        .subtract(1, 'year')
        .endOf('year')
        .format('YYYY-MM-DD')

      clearCalendar()
      calendarDateFrom.setDate(startOfLastYear)
      calendarDateTo.setDate(endOfLastYear)

      calendarDateFrom.set('enable', [
        { from: startOfLastYear, to: endOfLastYear },
      ])
      calendarDateTo.set('enable', [
        { from: startOfLastYear, to: endOfLastYear },
      ])

      break
    case 'custom':
      calendarDateFrom.clear()
      calendarDateTo.clear()
      clearCalendar()
      break
    default:
      calendarDateFrom.clear()
      calendarDateTo.clear()
      clearCalendar()
  }
}

function clearCalendar() {
  calendarDateFrom.set('enable', [''])
  calendarDateTo.set('enable', [''])
}
